import React, {useEffect} from 'react';
import {Wrap, WrapItem} from '@chakra-ui/react';

import {
  FaUserTie,
  FaRegTimesCircle,
  FaUsersCog,
  FaAddressCard,
  FaGlobeAmericas,
  FaRegFileExcel,
  FaFileInvoiceDollar,
  FaRegBuilding,
  FaCalculator,
  FaPersonBooth,
  FaSearchLocation,
  FaLayerGroup,
} from 'react-icons/fa';
import Card from '../../components/Maintenance/IconCard';
import {isAdmin} from '../../helpers/localStorage';

const Maintenance = props => {
  const [maintenanceScreens, setMaintenanceScreens] = React.useState([]); // These are the default maintenance cards that sales people can see

  useEffect(() => {
    const salesRoutes = [
      {Name: 'Client Maintenance', Icon: FaUserTie, RouteName: 'clients'},
      {Name: 'Arranger Maintenance', Icon: FaPersonBooth, RouteName: 'arrangers'},
      {Name: 'Location Maintenance', Icon: FaSearchLocation, RouteName: 'locations'},
      {Name: 'Master Maintenance', Icon: FaAddressCard, RouteName: 'master'},
      {Name: 'Opp Plan Maintenance', Icon: FaFileInvoiceDollar, RouteName: 'opportunity-plan'},
    ];
    // If the user is an admin, add these extra maintenance cards
    const userIsAdmin = isAdmin();
    if (userIsAdmin) {
      const extraRoutes = [
        {Name: 'User Maintenance', Icon: FaUsersCog, RouteName: 'users'},
        {Name: 'Region Maintenance', Icon: FaGlobeAmericas, RouteName: 'regions'},
        {Name: 'Exception Maintenance', Icon: FaRegTimesCircle, RouteName: 'exception'},
        {Name: 'Import Spreadsheets', Icon: FaRegFileExcel, RouteName: 'spreadsheets'},
        {Name: 'Import Revenue Spreadsheets', Icon: FaCalculator, RouteName: 'revenuespreadsheets'},
        {Name: 'Opp Plan Batch Maintenance', Icon: FaLayerGroup, RouteName: 'oppplanbatch'},
        {Name: 'Dept Maintenance', Icon: FaRegBuilding, RouteName: 'department'},
      ];
      setMaintenanceScreens([...salesRoutes, ...extraRoutes]);
    } else {
      setMaintenanceScreens(salesRoutes);
    }
  }, []);

  return (
    <div>
      <Wrap mt={'10'}>
        {maintenanceScreens.map((screen, idx) => {
          return (
            <WrapItem key={idx}>
              <Card name={screen.Name} icon={screen.Icon} route={'/maintenance/' + screen.RouteName} />
            </WrapItem>
          );
        })}
      </Wrap>
    </div>
  );
};

export default Maintenance;
